import { render, staticRenderFns } from "./Home2.vue?vue&type=template&id=1acdd16b&scoped=true"
import script from "./Home2.vue?vue&type=script&lang=js"
export * from "./Home2.vue?vue&type=script&lang=js"
import style0 from "./Home2.vue?vue&type=style&index=0&id=1acdd16b&prod&lang=scss"
import style1 from "./Home2.vue?vue&type=style&index=1&id=1acdd16b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acdd16b",
  null
  
)

export default component.exports